<script lang="ts">
	type FontSize =
		| 'hero'
		| 'primary'
		| 'secondary'
		| 'tertiary'
		| 'quaternary'
		| 'copy'
		| 'copy-additional';

	const fontSizeClassMap = {
		hero: 'text-hero',
		primary: 'text-primary',
		secondary: 'text-secondary',
		tertiary: 'text-tertiary',
		quaternary: 'text-quaternary',
		copy: 'text-copy',
		'copy-additional': 'text-copy-additional'
	};

	const responsiveFontSizeClassMap = {
		hero: 'text-primary lg:text-hero',
		primary: 'text-secondary md:text-primary',
		secondary: 'text-tertiary md:text-secondary',
		tertiary: 'text-quaternary md:text-tertiary',
		quaternary: 'text-quaternary',
		copy: 'text-copy-additional md:text-copy',
		'copy-additional': 'text-copy-additional'
	};

	let className = '';
	export { className as class };
	export let tag: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' = 'p';
	export let size: FontSize = 'primary';
	export let responsive = true;
</script>

<svelte:element
	this={tag}
	class={`font-extrabold ${
		responsive ? responsiveFontSizeClassMap[size] : fontSizeClassMap[size]
	} ${className ? className : ''}`}
	{...$$restProps}
>
	<slot />
</svelte:element>
